import { render, staticRenderFns } from "./SuporteEstagio.vue?vue&type=template&id=3b408761&"
import script from "./SuporteEstagio.vue?vue&type=script&lang=ts&"
export * from "./SuporteEstagio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports